import { render } from "./InnovationPostWithComment.vue?vue&type=template&id=0e05d42e&scoped=true"
import script from "./InnovationPostWithComment.vue?vue&type=script&lang=js"
export * from "./InnovationPostWithComment.vue?vue&type=script&lang=js"

import "./InnovationPostWithComment.vue?vue&type=style&index=0&id=0e05d42e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e05d42e"

export default script